import { Flex } from 'foundations-components/components/Flex';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PrimaryMessageFooter({
  children
}) {
  return /*#__PURE__*/_jsx(Flex, {
    "data-test-id": "primary-message-footer",
    marginBlockStart: "100",
    children: children
  });
}
PrimaryMessageFooter.displayName = 'PrimaryMessageFooter';
PrimaryMessageFooter.propTypes = {
  children: PropTypes.node.isRequired
};